import { PaletteColor, Theme } from '@mui/material/styles';

import { ColorProps } from '@/@mantis/types/extended';

export default function getColors(theme: Theme, color?: ColorProps | PaletteColor) {
  // Defensive check for theme and theme.palette
  if (!theme || !theme.palette) {
    return {
      lighter: '#e3f2fd',
      light: '#42a5f5',
      main: '#9D1500',
      primary: '#9D1500',
      dark: '#1565c0',
      darker: '#0d47a1',
      contrastText: '#fff',
    };
  }

  if (!color || typeof color === 'string') {
    switch (color) {
    case 'secondary':
      return theme.palette.secondary;
    case 'error':
      return theme.palette.error;
    case 'warning':
      return theme.palette.warning;
    case 'info':
      return theme.palette.info;
    case 'success':
      return theme.palette.success;
    default:
      return theme.palette.primary;
    }
  }

  return color;
}
